'use client'

import CogIcon from '@/components/icons/cog'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useSelectedLayoutSegment } from 'next/navigation'
import { useRouter } from 'nextjs-toploader/app'

export default function MobileNav() {
  const router = useRouter()
  const activeSegment = useSelectedLayoutSegment()
  const selectedSetting = activeSegment

  const allSettingsOptions = [
    { niceName: 'General', fullName: 'general' },
    { niceName: 'Notifications', fullName: 'notification-preferences' },
    { niceName: 'Connected Accounts', fullName: 'connected-accounts' },
    { niceName: 'Data & Privacy', fullName: 'privacy' },
    { niceName: 'Developer', fullName: 'developer' },
  ]

  const getValue = () => {
    const option = allSettingsOptions.find(
      (e) => e.fullName === selectedSetting,
    )
    return option ? option.fullName : 'general'
  }

  return (
    <div className="flex flex-col">
      <div className="mt-[95px] inline-block desktop-xs:mt-0 desktop-sm:hidden">
        <div className="absolute mt-[-50px] flex items-center">
          <CogIcon className="h-8 w-8 stroke-neutral-blue-50 stroke-2" />
          <div className="ml-2 text-[19px] font-semibold">Settings</div>
        </div>
        <div className="text-[19px] font-semibold">Profile Settings</div>
      </div>
      <div className="mt-8 inline-block desktop-sm:hidden">
        <Select
          onValueChange={(value) => {
            router.push(`/profile-manager/settings/${value}`, { shallow: true })
          }}
          defaultValue={getValue()}
          value={getValue()}
        >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select setting" />
          </SelectTrigger>
          <SelectContent className="w-(--radix-select-trigger-width)">
            {allSettingsOptions.map((option) => (
              <SelectItem key={option.fullName} value={option.fullName}>
                {option.niceName}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
